// Module
var code = "<div>\n    <h2 class=\"tw-font-bold tw-text-2xl lg:tw-text-3xl tw-text-black tw-mb-4 tw-mt-0\" ng-transclude=\"header\"></h2>\n    <div class=\"tw-text-lg tw-text-grey-darker-1\" ng-transclude=\"body\"></div>\n</div>\n";
// Exports
module.exports = code;